import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AccountDetailMenu } from '../components';
import { bindActionCreators } from 'redux';
import {
  selectAccount,
  selectAccountFullName,
  selectAccountRole,
  fetchAccountActions,
} from '../ducks';
import { selectIsCallCentrum } from '../../auth/ducks';
import { Alert } from 'antd'
import accountRoles from '../../../common/enums/accountRoles';
import { formatDate } from '../../../common/utils/helpers';

const mapStateToProps = (state, props) => ({
  account: selectAccount(state),
  accountFullName: selectAccountFullName(state),
  accountRole: selectAccountRole(state),
  accountId: props.params.accountId,
  isCallCentrum: selectIsCallCentrum(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchAccount: fetchAccountActions.request,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class AccountDetailWrapper extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    actions: PropTypes.object.isRequired,
    account: PropTypes.object,
    accountFullName: PropTypes.string,
    accountRole: PropTypes.string,
    accountId: PropTypes.string.isRequired,
    isCallCentrum: PropTypes.bool.isRequired,
  };

  componentDidMount() {
    const { actions, accountId } = this.props;
    actions.fetchAccount({ accountId });
  }

  componentDidUpdate(prevProps) {
    const { actions, accountId } = this.props;
    if (prevProps.accountId !== accountId) {
      actions.fetchAccount({ accountId });
    }
  }

  render() {
    const { children, account, accountFullName, accountRole, accountId, isCallCentrum } = this.props;

    if (!account) {
      return null;
    }

    return (
      <div>
        {
          accountRole === accountRoles.DEBTOR && account.blacklist.length > 0 &&
          <Alert type="error" description={
            <p>
              {account.blacklist.map(record => {
                return <p style={{color: 'black'}}>{`Pôžička tohto užívateľa s VS ${record.loanNumber} zaradená do Blacklistu od ${formatDate(record.created)} s poznámkou: ${record.note ? record.note : 'Bez poznámky'}`}</p>
              })}
            </p>
          }/>
        }
        {!isCallCentrum &&
          <AccountDetailMenu
            accountFullName={accountFullName}
            accountRole={accountRole}
            accountId={accountId}
          />
        }
        {cloneElement(children, { account, accountId })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/account-management/containers/AccountDetailWrapper.js